module.exports = __webpack_public_path__ + "static/media/main_myjob_icon_3.5e48eedf.svg";